import { Collapse, CollapseItem, Button, Popover, Select, Option, } from 'element-ui';
import moment from 'moment';
import 'element-ui/lib/theme-chalk/index.css';
import ResourceSvc from '@/services/resource.svc.js';
const request = new ResourceSvc();

export default {
    name: 'RacesView',
    props: ['races'],
    components: {
        [Collapse.name]: Collapse,
        [CollapseItem.name]: CollapseItem,
        [Button.name]: Button,
        [Popover.name]: Popover,
        [Select.name]: Select,
        [Option.name]: Option
    },
    data() {
        return {
            isProcessing: false,
            activeRaceId: null,
            expandData: [],
            cardData: [],
            raceStatusCompleted: "Completed",
            raceStatusFull: 'Full',
            raceStatusActive: 'Active',
            yes: 'Yes',

            //region: is show expand open for data
            openFor: false,
            openForRelay: false,
            openFor1: false,
            openForRelay1: false,
            openFor2: false,
            openForRelay2: false,
            openFor3: false,
            openForRelay3: false
            //endregion
        };
    },
    computed: {
        isAnyRacesLoaded() {
            return this.races && this.races.length;
        },
        yesterdayDate() {
            var d = new Date();
            return d.setDate(d.getDate() - 1);
        }
    },
    methods: {
        isYes(input) {
            if (input == this.yes) {
                return true;
            }
            else { return false; }
        },
        isButtonRegistration(race) {
            const now = Date.now();

            return race['Race Status'] == this.raceStatusActive
                && (race['Open Places For Relay'] > 0 || race['Open Places For Individual'] > 0 )
                && this.isYes(race['TI Entry System (Yes/No)'])
                && new Date(race['Event Date']) >= this.yesterdayDate
                && ((new Date(race['Opening Date For Entries']) <= now && new Date(race['Closing Date For Entries']) > now)
                || (new Date(race['#1 Opening Date For Entries']) <= now && new Date(race['#1 Closing Date For Entries']) > now)
                || (new Date(race['#2 Opening Date For Entries']) <= now && new Date(race['#2 Closing Date For Entries']) > now)
                || (new Date(race['#3 Opening Date For Entries']) <= now && new Date(race['#3 Closing Date For Entries']) > now));
        },
        isRegistrationClosed(race) {
            return race['Race Status'] == this.raceStatusActive && new Date(race['Event Date']) >= this.yesterdayDate;
        },
        isButtonODL(race) {
            const now = Date.now();
            return this.isYes(race['Odl Info(Yes/No, Opening/Closing)'])
                && !this.isYes(race['TI Entry System (Yes/No)'])
                && new Date(race['One Day License Open Date']) <= now
                && new Date(race['One Day License Close Date']) > now;
        },
        isButtonEnterODL(race) {
            const now = Date.now();
            return this.isYes(race['Odl Info(Yes/No, Opening/Closing)'])
                && !this.isYes(race['TI Entry System (Yes/No)'])
                && new Date(race['One Day License Open Date']) <= now
                && new Date(race['One Day License Close Date']) > now;
        },
        loadRaceCardInfo() {
            this.$parent.loadRaceCard(this.activeRaceId);
        },
        getExpandInfo() {
            let self = this;
            if (self.activeRaceId && self.activeRaceId != null) {

                if (self.isProcessing) {
                    return;
                }

                self.$parent.isCardVisible = false;
                self.isProcessing = true;
                request.raceCalendarExpandInfo(self.activeRaceId)
                    .then(res => {
                        if (res && res.body && res.body.isSuccess) {
                            self.expandData = res.body.outputData[0];
                            self.isProcessing = false;
                        }
                        else {
                            self.$showError(res && res.body && res.body.message ? res.body.message : null, 5000);
                        }
                    },
                        err => {
                            self.isProcessing = false;
                            self.$showError(5000);
                        })
                    .then( () => {
                      let active = self.$el.querySelector('#heads-' + self.activeRaceId).closest('div.el-collapse-item.mb-0');
                      let parent = document.querySelector('div#race-calendar-list');
                      parent.scrollTop = active.offsetTop - active.firstChild.offsetHeight;
                  });
            }
        },
        resetCart(func) {
            self.isProcessing = true;
            request.resetCart()
                .then(res => {
                    self.isProcessing = false;
                    if (res && res.body && res.ok && res.body.isSuccess) {
                        if (typeof func === 'function') {
                            func();
                        }
                    } else {
                        self.$showError("Something went wrong. Contact with DEV team!");
                    }
                },
                    () => {
                        self.isProcessing = false;
                        self.$showError("Something went wrong. Contact with DEV team!");
                    });
        },
        enterRace(rId) {
            if (rId != null) {
                this.resetCart(() => {
                    this.$router.push({ path: '/race-entry/' + rId });
                });
            }
        },
        enterODM(rId) {
            if (rId != null) {
                this.resetCart(() => {
                    this.$router.push({ path: '/race-odl?rId=' + rId });
                });
            }
        },
        enterLink(link) {
            if (link != null) {
                var win = window.open(link, '_blank');
                win.focus();
            }
        }
    },
    filters: {
        formatDate: function (value) {
            if (value) {
                return moment(String(value)).format('DD/MM/YYYY');
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/user/race-events/race-calendar/table/table.js